module.exports = __webpack_public_path__ + "img/central-klaus-3.deee0ffa.jpg";